export class TenderTabNameModel {
    expired = 'EXPIRED';
    active = 'ACTIVE';
}